import { IntlMessageFormat as f } from "./index78.mjs";
import { useCallback as u } from "react";
const p = (s, r, o) => (e, n) => {
  if (e === void 0) return "";
  const a = r(e);
  if (o && (e = o(e)), !a)
    return console.warn(
      `Can't find namespace. Make sure you pass all used namespaces in the getBaseServerSideProps. Some troubles with "${e}"`
    ), "";
  for (let c of a) {
    const t = s(e, { ns: c, ...n });
    if (t && t !== e) return t;
  }
  return e;
}, m = (s, r, o) => (e, n, a) => {
  const c = p(s, r, o);
  try {
    const t = c(e, a);
    if (!t) return "";
    const i = new f(t).format(n);
    return Array.isArray(i) ? i.join("") : i;
  } catch (t) {
    return console.error(`tICU formatting error for key "${e}":`, t), "";
  }
}, y = ({
  useTranslation: s,
  defaultNamespaces: r,
  namespaceMapper: o,
  assetKeyMapper: e
}) => function(n = []) {
  const { t: a, ...c } = s([...r, ...n]), t = u(p(a, o, e), [a]), i = u(m(a, o, e), [
    a
  ]);
  return { t, tICU: i, ...c };
};
export {
  p as getTFuncWithNamespace,
  m as getTICUFuncWithNamespace,
  y as getUseLocoTranslation
};
